<template>
  <div id="wrapper">
    <div>
      <span>Room Id:</span><span class="bold">{{greenroom.id}}</span>
    </div>
    <div>
      <span>Your Peer Id:</span><span class="bold">{{greenroom.peerId}}</span>
    </div>
    <div>
      <span>Active speaker:</span><span class="bold">{{activeSpeaker}}</span>
    </div>
    <div class="add-feed">
      <div class="selection-row">
        <label>Webcam</label>
        <select ref="webcam">
          <option v-for="webcam in manager.webcams.models" v-bind:value="webcam.deviceId">{{webcam.label}}
          </option>
        </select>
      </div>
      <button @click="addWebcam">Add webcam</button>
      <div class="selection-row">
        <label>Microphone</label>
        <select ref="mic">
          <option v-for="mic in manager.microphones.models" v-bind:value="mic.deviceId">{{mic.label}}
          </option>
        </select>
      </div>
      <button @click="addMic">Add microphone</button>
    </div>
    <div>
      <h2>Active Media</h2>
      <div class="list" v-for="media in greenroom.media.models">
        <Media :media="media" :show="show"></Media>
      </div>
      <h2>Peers</h2>
      <div class="list" v-for="peer in greenroom.peers.models">
        <li>
          <h3>{{peer.id}}</h3>
          <div>displayName: {{peer.displayName}}</div>
          <div>isHost: {{peer.isHost}}</div>
        </li>
        <h3>Media</h3>
        <li class="list">
          <div>
            <h4>Webcam</h4>
            <Media v-if="peer.webcam" :media="peer.webcam" :show="show"></Media>
          </div>
          <div>
            <h4>Microphone</h4>
            <Media v-if="peer.microphone" :media="peer.microphone" :show="show"></Media>
          </div>
          <div>
            <h4>Screen</h4>
            <Media v-if="peer.screen" :media="peer.screen" :show="show"></Media>
          </div>
          <div>
            <h4>Audio</h4>
            <Media v-if="peer.audio" :media="peer.audio" :show="show"></Media>
          </div>
        </li>
      </div>
    </div>
    <video ref="video" autoplay></video>
  </div>
</template>

<script>
  import webrtc from '../webrtc/webrtc-manager'
  import {RoomModel} from '../webrtc/greenroom-room-model'
  import Logger from '../webrtc/logger'
  import MediaItem from './items/Media'
  import randomString from 'random-string'
  import UrlParse from 'url-parse'
  import {result} from 'lodash'
  const logger = Logger.create('WebRTC:Room:Overview')

  const getQueryParams = () => {
    const pl = /\+/g // Regex for replacing addition symbol with a space
    const search = /([^&=]+)=?([^&]*)/g
    const decode = s => decodeURIComponent(s.replace(pl, " "))
    const query = window.location.href.split('?')[1]
    const urlParams = {}
    let match
    while (match = search.exec(query)) {
      urlParams[decode(match[1])] = decode(match[2])
    }
    logger.info('Got query params', urlParams)
    return urlParams
  }

  export default {
    name: 'Room',
    data () {
      return {
        greenroom: {
          media: [

          ],
          peers: [
            
          ]
        },
        manager: {
          webcams: {
            models: [{
              deviceId: '',
              label: ''
            }]
          },
          microphones: {
            models: [{
              deviceId: '',
              label: ''
            }]
          }
        },
        activeSpeaker: '',
        microphone: {},
        webcam: {},
        stream: null
      }
    },
    props: {
      roomId: {
        type: '',
        required: true
      }
    },
    async mounted () {
      document.querySelector('#app').setAttribute('data-view', 'room')
      window.room = this
      let hostname = window.location.hostname

      try {
        let roomReq = await fetch(`https://${hostname}/api/webrtc/room/${this.roomId}`)
        let roomInfo = await roomReq.json()
        if (roomInfo.host) {
          hostname = roomInfo.host
        }
      } catch (e) {
      }

      logger.info(`Selected shard`, {hostname})

      const queryParams = getQueryParams()
      const {peerId} = queryParams

      this.manager = webrtc
      await this.manager.updateDevices()
      this.greenroom = window.greenroom = this.manager.ensureRoom(this.roomId, {peerId, id: this.roomId, displayName: 'Engine', serverHostname: hostname, serverPort: 3443})
      this.manager.joinRoom(this.roomId)

      this.greenroom.listenTo(this.greenroom, 'change:activeSpeaker', () => {
        this.activeSpeaker = this.greenroom.activeSpeaker
      })
    },
    methods: {
      async addWebcam () {
        const webcamId = this.$refs.webcam.value
        const webcam = this.manager.webcams.get(webcamId)
        const track = await webcam.getTrack()
        this.greenroom.addMedia({deviceId: webcam.deviceId, peerId: this.greenroom.peerId, type: 'videoFeed', track})
      },
      async addMic () {
        const micId = this.$refs.mic.value
        const mic = this.manager.microphones.get(micId)
        const track = await mic.getTrack()
        this.greenroom.addMedia({deviceId: mic.deviceId, peerId: this.greenroom.peerId, type: 'audioFeed', track})
      },
      show (evt) {
        const el = evt.target
        const mediaId = el.dataset.mediaId
        const media = this.greenroom.media.get(mediaId)
        const isVideo = media.type === 'webcam' || media.type === 'screen'
        if (isVideo) {
          if (this.activeVideo) {
            this.activeVideo.off('change:track')
            this.activeVideo.showing = false
          }
          this.activeVideo = (this.activeVideo && media === this.activeVideo) ? null : media
          if (this.activeVideo) this.activeVideo.showing = true
        } else {
          if (this.activeAudio) {
            this.activeAudio.off('change:track')
            this.activeAudio.showing = false
          }
          this.activeAudio = (this.activeAudio && media === this.activeAudio) ? null : media
          if (this.activeAudio) this.activeAudio.showing = true
        }
        media.listenToAndRun(media, 'change:track', () => {
          const stream = new MediaStream()
          if (this.activeVideo && this.activeVideo.track) stream.addTrack(this.activeVideo.track)
          if (this.activeAudio && this.activeAudio.track) stream.addTrack(this.activeAudio.track)
          this.$refs.video.srcObject = stream
        })
      }
    },
    components: {Media: MediaItem}
  }
</script>
<style>
  #app[data-view="room"] {
    position: relative;
  }

  #app[data-view="room"] .bold {
    font-weight: 700;
  }

  #app[data-view="room"] .list {
    margin: 14px;
    border-left: 6px solid grey;
    padding-left: 14px;
  }

  #app[data-view="room"] li {
    list-style-type: none;
  }

  #app[data-view="room"] h1, #app[data-view="room"] h2, #app[data-view="room"] h3, #app[data-view="room"] h4, #app[data-view="room"] h5, #app[data-view="room"] h6 {
    margin: 6px 0;
  }

  #app[data-view="room"] #wrapper {
    position: absolute;
    margin: 0 !important;
  }

  #app[data-view="room"] *:not(.li) {
    padding: 2px 4px;
  }

  #app[data-view="room"] video {
    position: fixed;
    max-width: 50%;
    top: 20px;
    right: 20px;
    height: auto;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// Room.vue?5eb680d8